/**
 * Calls an API with a given URL and Api parameters, returns JSON response
 * @param {string} apiUrl - Base API URL
 * @param {Object} [apiParams={}] - Query parameters
 * @returns {Promise<Object>} - JSON response
 */
export const callApi = async (apiUrl, apiParams = {}) => {
    try {
      const response = await fetch(apiUrl, apiParams);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await (response.status === 200 ? response.json() : {message:response.text()});
      return data;
    } catch (error) {
      console.error('API call error:', error);
      throw error;
    }
  };
  